module.exports = __webpack_public_path__ + "img/4.a26b02a7.png";